import { render, staticRenderFns } from "./tmScrollSensor.vue?vue&type=template&id=505796b0&scoped=true&"
import script from "./tmScrollSensor.vue?vue&type=script&lang=js&"
export * from "./tmScrollSensor.vue?vue&type=script&lang=js&"
import style0 from "./tmScrollSensor.vue?vue&type=style&index=0&id=505796b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505796b0",
  null
  
)

export default component.exports